// extracted by mini-css-extract-plugin
export default {"description":"oxhkjSmsO9dVcWGTdywY","descriptionMobile":"TvoyqrneTzsFJDvejMFg","row":"csfk5pvDKGvlon9146HZ","column":"tUD5gqm8a1Pm0d_DiCeE","grey":"gMDx9c5IWDTHIoGi14Bx"};